function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  transform: "translate(-400.000000, -316.000000)",
  fill: "#FFB400",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "button-jobs-copy",
  transform: "translate(343.000000, 262.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-contacts",
  transform: "translate(57.000000, 54.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.326925,23.0769231 C32.7029799,23.0769231 37.8461538,17.9039063 37.8461538,11.5384615 C37.8461538,5.17301683 32.7029799,0 26.326925,0 C19.9508702,0 14.7692308,5.17301683 14.7692308,11.5384615 C14.7692308,17.9039063 19.9510508,23.0769231 26.326925,23.0769231 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.2290906,30.4615385 C56.1199478,30.4615385 54.8770698,30.5385216 53.5384615,30.6730168 C57.9748533,33.8844952 61.053455,38.2114183 61.053455,43.9229567 L61.053455,53.5384615 L84,53.5384615 L84,43.923137 C84,34.9615385 66.1590613,30.4615385 57.2290906,30.4615385 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.7115404,23.0769231 C64.0875953,23.0769231 69.2307692,17.9039063 69.2307692,11.5384615 C69.2307692,5.17301683 64.0875953,0 57.7115404,0 C51.3354856,0 46.1538462,5.17301683 46.1538462,11.5384615 C46.1538462,17.9039063 51.3354856,23.0769231 57.7115404,23.0769231 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.7691411,30.4615385 C17.8397603,30.4615385 0,34.9615385 0,43.923137 L0,53.5384615 L53.5384615,53.5384615 L53.5384615,43.923137 C53.5384615,34.9615385 35.6987012,30.4615385 26.7691411,30.4615385 Z",
  id: "Path"
})))));

function SvgIconContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "54px",
    viewBox: "0 0 84 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContacts);
export default __webpack_public_path__ + "static/media/icon-contacts.9d81bb5a.svg";
export { ForwardRef as ReactComponent };